import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { H2, P } from 'components/rebrand/Typography';

import { IImgBlockContent } from 'typescriptDefs';

type Props = {
  heading: string;
  rewards: IImgBlockContent[];
  subheading: string;
};

const Rewards = ({ heading, rewards, subheading }: Props) => {
  return (
    <Section className="bg-primary-50">
      <Container className="px-32 py-64 md:px-[unset] md:py-96">
        <H2 className="mb-20 text-center text-primary-350">{heading}</H2>
        <P className="mb-48 text-center">{subheading}</P>
        {rewards.map((reward, index) => (
          <div className="mb-32 grid gap-32 md:grid-cols-2">
            <div
              className={twMerge(
                clsx('order-2 overflow-hidden rounded-16 md:order-[unset]', index % 2 != 0 && 'md:!order-2'),
              )}
            >
              <div className="hidden md:block">
                <GatsbyImage alt={reward.img.altText} image={reward.img.img.asset.gatsbyImageData} />
              </div>
              <div className="block md:hidden">
                <GatsbyImage alt={reward.img.altText} image={reward.mobileImg!.asset.gatsbyImageData} />
              </div>
            </div>
            <div className="rounded-16 bg-primary-500 px-32 py-60 text-white md:p-32">
              <CustomPortableText
                headingStyles={{
                  h2: {
                    className: 'mb-18 w-[85%] text-3xl font-bold text-primary-100 md:mb-8 md:w-auto md:text-4xl',
                    headingStyle: true,
                  },
                }}
                content={reward.content}
              />
            </div>
          </div>
        ))}
      </Container>
    </Section>
  );
};

export default Rewards;
